module.exports = __webpack_public_path__ + "images/emoji/cn.716c966021635af2e7fe.png";